export default __webpack_public_path__ + "static/media/DP3.0b459ed3.svg";